import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

import { axiosInt, API_CORE_URL } from '../../../utils';
import type { ICursorPaginateMeta } from '../../../types';
import type { IModelInstanceParams } from './useFetchModelInstancesCursorPagination';

export const FETCH_MODEL_INSTANCES_CURSOR_PAGINATION_META_KEY =
  'fetchModelInstancesCursorPaginationMeta';
export const fetchModelInstancesCursorPaginationMetaApi = async (
  params?: IModelInstanceParams
): Promise<ICursorPaginateMeta> => {
  const response = await axiosInt.get(
    `${API_CORE_URL}/model-instances/cursor-pagination/meta`,
    {
      params,
    }
  );
  return response.data;
};

const useFetchModelInstancesCursorPaginationMeta = ({
  params,
  options,
}: {
  params?: IModelInstanceParams;
  options?: Partial<UseQueryOptions<ICursorPaginateMeta>>;
} = {}) => {
  const {
    data: modelInstancesMeta,
    isLoading: isLoadingModelInstancesMeta,
    error: errorFetchingModelInstancesMeta,
  } = useQuery<ICursorPaginateMeta>({
    queryKey: [FETCH_MODEL_INSTANCES_CURSOR_PAGINATION_META_KEY, params],
    queryFn: () => fetchModelInstancesCursorPaginationMetaApi(params),
    ...options,
  });

  return {
    modelInstancesMeta,
    isLoadingModelInstancesMeta,
    errorFetchingModelInstancesMeta,
  };
};

export default useFetchModelInstancesCursorPaginationMeta;
